import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * router that depends on 'token' query params
 *
 * @example
 *
 * canActivate: [appRedirectGuard],
 */

export const appRedirectGuard = (
  route: ActivatedRouteSnapshot
  // router: Router // Pass router as an argument
): Observable<boolean | UrlTree> => {
  const lang = route.queryParams['lang'];
  const token = route.queryParams['token'];
  const router = inject(Router);

  if (!token) {
    return of(
      router.createUrlTree(['access-denied'], {
        queryParams: { lang: lang, type: 'invalid' },
      })
    );
  } else {
    let data: any;
    try {
      data = JSON.parse(window.atob(token.split('.')[1]));
    } catch (error) {
      // do nothing
      return of(
        router.createUrlTree(['access-denied'], {
          queryParams: { lang: lang, type: 'invalid' },
        })
      );
    }
    const now = new Date();
    const current_epoch = Math.round(now.getTime() / 1000);
    if (data?.exp < current_epoch) {
      return of(
        router.createUrlTree(['access-denied'], {
          queryParams: { lang: lang, type: 'expired' },
        })
      );
    } else {
      return of(true);
    }
  }
};
